// extracted by mini-css-extract-plugin
export default {"container":"EditMessageForm_container__GDkNS","image_preview":"EditMessageForm_image_preview__Agps5"};